import { PreRenderService } from './../../services/pre-render.service';
import { Component, OnInit, OnChanges, SimpleChanges, Renderer2, Input, Output, EventEmitter, HostListener, ViewChild, ElementRef, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit, OnChanges {
  @Input() readonly shouldShowModal: boolean = false;

  // TODO: There exists a bug where if this is set to true, clicking the contactByPhone button causes the modal to close
  @Input() readonly allowOutsideClickToClose: boolean = true;
  @Input() readonly isFullHeight: boolean = false;
  @Input() readonly templateRef: TemplateRef<any>;
  @Input() readonly isRedesign: boolean = false;
  @Input() isLandingPage: boolean = false;
  @Input()  size: string = '';
  @Output() closeModal: EventEmitter<void> = new EventEmitter();
  @ViewChild('modalRef') modalRef: ElementRef;
  @ViewChild('hiddenAnchor') hiddenAnchor: ElementRef;

  shouldNotFocus: boolean;
  constructor(private _renderer: Renderer2,
    private _preRenderService: PreRenderService
  ) { }

  ngOnInit() {
  }

  // If focus moving outside of modal, move focus back to start of modal.
  checkFocus(event: FocusEvent) {
    setTimeout(() => {
      if (!!this.modalRef && !this.modalRef.nativeElement.contains(event.relatedTarget) && !this.shouldNotFocus) {
        this.hiddenAnchor.nativeElement.focus();
        event.preventDefault();
        event.stopPropagation();
      }
    }, 0);
  }

  ngOnChanges(changes: SimpleChanges) {
    // TODO: have to deal with the page going to the top
    // have to wait for the next cycle before checking the length
    setTimeout(() => {
      if (changes && changes.shouldShowModal && changes.shouldShowModal.currentValue) {
        this._renderer.addClass(document.querySelector('html'), 'no-scroll');
        this.hiddenAnchor.nativeElement.focus();
      } else if (!changes.shouldShowModal.currentValue && this._preRenderService.isBrowserMode && document.getElementsByClassName('remax-modal').length === 0) {
        this._renderer.removeClass(document.querySelector('html'), 'no-scroll');
      }
    });
  }

  @HostListener('keydown.esc', ['$event'])
  @HostListener('click', ['$event'])
  onPageClick($event) {
    // set shoudlNotFocus check on a click before checkFocus()
    // prevents scroll up issue triggered by a focus out event
    this.shouldNotFocus = true;
    // disable shoudlNotFocus after checkFocus() function runs through
    // needs to be set here because checkFocus() might not run
    setTimeout(() => {
      this.shouldNotFocus = false;
    }, 1);

    if (this.shouldShowModal && ((this.allowOutsideClickToClose && !this.modalRef.nativeElement.contains($event.target)) || $event.key === 'Escape')) {
      this.closeModal.emit();
      event.stopPropagation();
    }
  }

}
